import React, {useState, useRef} from 'react';
import UserTable from '@/page/customer/InheritPage/UserTable';
import {transfer} from '@/api/customer';
import {message, notification} from 'antd';
import StepModal from '@/page/customer/InheritPage/StepModal';
import {useEditAuthService} from '@/page/admin/adminService';

export default function OnPage() {
    const editable = useEditAuthService(['global:customer_onjob_inherit:w']);
    const modalRef = useRef();
    const [user, setUser] = useState({});

    function open(record) {
        setUser(record);
        modalRef.current.open();
    }

    function renderContent(result) {
        const {externalUserId, errcode} = result;
        return (
            <>
                <p>{'客户ID：' + externalUserId}</p>
                <p>{'错误码：' + errcode}</p>
                <a
                    href={'https://open.work.weixin.qq.com/devtool/query?e=' + errcode}
                    target="_blank"
                >
                    点击查询具体错误
                </a>
            </>
        );
    }

    function getResult(toUserId, extUserIds) {
        const params = {
            fromUserId: user.extId,
            toUserId: toUserId,
            extUserIds: extUserIds,
            transferType: '1',
        };
        transfer(params).then(res => {
            if (res.data.errcode === 0) {
                message.success('移交成功');
            } else {
                message.error('移交失败:' + res.data.errcode + '_' + res.data.errmsg);
                res.data.customers.forEach(item => {
                    if (item.errcode === 0) {
                        notification.success({
                            message: '客户移交成功',
                            description: <p>{'客户ID：' + item.externalUserId}</p>,
                        });
                    } else {
                        notification.error({
                            message: '客户移交失败',
                            description: renderContent(item),
                        });
                    }
                });
            }
        });
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <UserTable openModal={open} editable={editable}/>
            <StepModal ref={modalRef} user={user} getResult={getResult} />
        </div>
    );
}
